import { actionTypes } from "./retirePet.actions";

export interface IRetirePet {
  petName: string;
  petId: string;
  retireReason: string;
  reasonDescription: string;
  isPetDeleted: boolean;
}


const initialState: IRetirePet = {
  petName: "",
  petId: "",
  retireReason: "",
  reasonDescription: "",
  isPetDeleted: false,
};

export const retirePetReducer = (
  state: IRetirePet = initialState,
  action: { type: string, payload: string },
) => {
  switch (action.type) {
  case actionTypes.SET_PET_NAME:
    return {
      ...state,
      petName: action.payload,
    };
  case actionTypes.SET_PET_ID:
    return {
      ...state,
      petId: action.payload,
    };
  case actionTypes.SET_RETIRE_REASON:
    return {
      ...state,
      retireReason: action.payload,
    };
  case actionTypes.SET_REASON_DESCRIPTION:
    return {
      ...state,
      reasonDescription: action.payload,
    };
  case actionTypes.SET_DELETED_STATUS:
    return {
      ...state,
      isPetDeleted: action.payload,
    };
  default:
    return state;
  }
};
